import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// LAYOUT
import AdminRedirect from "./routes/AdminRedirect";
import Header from './components/Header';
import Footer from './components/Footer';
import MobileNavbar from './components/MobileNavbar';
import ScrollToTop from './components/ScrollToTop';
import FloatingButtons from './components/FloatingButtons';

// COMPANY
import ContactUsPage from './pages/ContactUsPage';
import AboutPage from './pages/AboutPage';

// AUTH
import LoginPage from './pages/auth/LoginPage';
import RegisterUser from './pages/auth/RegisterUser';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetCodePage from './pages/auth/ResetCodePage';
import UpdatePasswordPage from './pages/auth/UpdatePasswordPage';
import AuthRequired from "./pages/AuthRequired";

// PROFILES
import ChooseProfile from './pages/ChooseProfile';
import RegistrationSuccess from './pages/RegistrationSuccessful';
import RegisterBusiness from './pages/RegisterBusiness';
import BusinessDetailsPage from './pages/BusinessDetailsPage';
import ChatsPage from './pages/ChatsPage';

// SOLUTIONS
import SolutionsPage from './pages/SolutionsPage';
import PricingPage from './pages/PricingPage';
import MagyneCheckInsPage from './pages/MagyneCheckInsPage.js';
import MagyneSchoolPage from './pages/MagyneSchoolPage';
import MagyneCarwashPage from "./pages/MagyneCarwashPage";
import MagyneMedicPage from './pages/MagyneMedicPage';
import MagyneCampusPage from "./pages/MagyneCampusPage.js";

// PAGES
import LandingPage from './pages/LandingPage';
import ProtectedRoute from "./routes/ProtectedRoute";
import PageNotFound from './pages/PageNotFound';

// policy
import RoadmapPage from './pages/roadmap/RoadmpaPage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import TermsOfUsePage from './pages/legal/TermsOfUsePage';
import CookiePolicyPage from './pages/legal/CookiePolicyPage';
import SecurityCompliancePage from './pages/legal/SecurityCompliancePage';
import DataProcessingAgreementPage from './pages/legal/DataProcessingAgreementPage';
import AcceptableUsePage from './pages/legal/AcceptableUsePage';
import DocumentationPage from './pages/documentation/DocumentationPage';
import SystemStatusPage from './pages/documentation/SystemStatusPage';
import ServiceLevelAgreementPage from './pages/legal/ServiceLevelAgreementPage';


function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="admins" element={<AdminRedirect />} />
        <Route path="/*" element={<PageNotFound />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterUser />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/verify-otp" element={<ResetCodePage />} />
        <Route path="/auth-required" element={<AuthRequired />} />
        <Route path="/registration-success" element={<RegistrationSuccess />} />
        
        <Route path="/chats" element={<ProtectedRoute> <ChatsPage /> </ProtectedRoute>} />

        <Route path="/choose-profile" element={<ProtectedRoute> <ChooseProfile /> </ProtectedRoute>} />
        <Route path="/update-password" element={<ProtectedRoute> <UpdatePasswordPage /> </ProtectedRoute>} />
        <Route path="/register/:productId/:planId" element={<RegisterBusiness />} />

        <Route path="/business/" element={<ProtectedRoute> <BusinessDetailsPage /> </ProtectedRoute>} />
        
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/solutions/school" element={<MagyneSchoolPage />} />
        <Route path="/solutions/carwash" element={<MagyneCarwashPage />} />
        <Route path="/solutions/medic" element={<MagyneMedicPage />} />
        <Route path="/solutions/checkins" element={<MagyneCheckInsPage />} />
        <Route path="/solutions/campus" element={<MagyneCampusPage />} />
        
        {/* Company */}
        <Route path="/roadmap" element={<RoadmapPage />} />

        {/* Resources */}
        <Route path="/documentation" element={<DocumentationPage />} />
        <Route path="/system-status" element={<SystemStatusPage />} />

        {/* Legal */}
        <Route path="/sla" element={<ServiceLevelAgreementPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfUsePage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route path="/security" element={<SecurityCompliancePage />} />
        <Route path="/dpa" element={<DataProcessingAgreementPage />} />
        <Route path="/acceptable-use" element={<AcceptableUsePage />} />
      </Routes>
      {/* Floating Shapes */}
      <div className="floating-shape shape1"></div>
      <div className="floating-shape shape2"></div>
      <div className="floating-shape shape3"></div>
      <FloatingButtons />
      <Footer />
      <MobileNavbar />
    </>
  );
}

export default App;
